import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_REFUELING } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Refuelings from '../../components/Refuelings';

// Optional search params (deep-link / row-action filters); never fail validation.
const refuelingsEditSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
  locked: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/refuelings/edit/$id')({
  validateSearch: refuelingsEditSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.refuelingsOverview',
      },
    };
  },
  // Modal opened by the Refuelings list based on the URL.
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  const { id } = Route.useParams();
  const { customerId, locked } = Route.useSearch();

  return (
    <Refuelings mode="edit" refuelingId={Number(id)} customerId={customerId} locked={locked} />
  );
}
